// extracted by mini-css-extract-plugin
export var brand = "_53-9";
export var compact = "_53-6";
export var extraSmall = "_53-7";
export var icon = "_53-0";
export var large = "_53-4";
export var light = "_53-1";
export var medium = "_53-5";
export var outline = "_53-b";
export var primaryDark = "_53-a";
export var primaryLight = "_53-8";
export var primaryModern = "_53-c";
export var success = "_53-2";
export var successSolid = "_53-3";